<div class="modal-header">
  <h4 class="modal-title">Agent Log</h4>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body p-3">
  <!-- Filters -->
  <div class="d-flex flex-row flex-wrap gap-2 align-items-end mb-3">
    <div>
      <label class="form-label mb-1">Filter By</label>
      <select class="form-select form-select-sm" [(ngModel)]="data.type" (change)="switchType()">
        <option value="today">Today</option>
        <option value="yesterday">Yesterday</option>
        <option value="last7">Last 7 Days</option>
        <option value="last30">Last 30 Days</option>
        <option value="this_month">This Month</option>
        <option value="last_month">Last Month</option>
        <option value="week">Week</option>
        <option value="day">Day</option>
        <option value="custom">Custom Range</option>
      </select>
    </div>
    <div *ngIf="data.type === 'week'" style="min-width:200px">
      <label class="form-label mb-1">Select Week</label>
      <ng-select bindLabel="label" bindValue="value" [items]="dates" [clearable]="false" [(ngModel)]="data.week_number"></ng-select>
    </div>
    <div *ngIf="data.type === 'day'">
      <label class="form-label mb-1">Date</label>
      <input type="date" class="form-control form-control-sm" [max]="today" [(ngModel)]="data.date" />
    </div>
    <ng-container *ngIf="data.type === 'custom'">
      <div>
        <label class="form-label mb-1">From</label>
        <input type="date" class="form-control form-control-sm" [max]="today" [(ngModel)]="custom_from" />
      </div>
      <div>
        <label class="form-label mb-1">To</label>
        <input type="date" class="form-control form-control-sm" [max]="today" [(ngModel)]="custom_to" />
      </div>
    </ng-container>
    <button class="btn btn-primary btn-sm" (click)="filter()" [disabled]="is_loading_logs">Filter</button>
  </div>

  <!-- Loading -->
  <div class="text-center py-4" *ngIf="is_loading_logs">
    <div class="spinner-border"></div>
  </div>

  <!-- No Data -->
  <div *ngIf="!is_loading_logs && logs.length === 0">
    <p class="text-muted">No data available.</p>
  </div>

  <!-- Table -->
  <div class="table-responsive" *ngIf="!is_loading_logs && logs.length > 0">
    <table class="table table-sm table-hover table-bordered mb-0">
      <thead class="table-dark">
        <tr>
          <th>#</th>
          <th>Code</th>
          <th>Agent</th>
          <th class="text-end">In</th>
          <th class="text-end">Out</th>
          <th class="text-end">Profit</th>
          <th class="text-end">Commission</th>
          <th class="text-end">Withdrawn</th>
          <th class="text-end">Balance</th>
          <th class="text-center">Detail</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let log of logs; let i = index">
          <td class="text-muted small">{{i + 1}}</td>
          <td><span class="badge bg-secondary">{{log.code || '-'}}</span></td>
          <td>{{log.name || '-'}}</td>
          <td class="text-end text-primary small">{{log.total_in | number:'1.2-2'}}</td>
          <td class="text-end text-danger small">{{log.total_out | number:'1.2-2'}}</td>
          <td class="text-end fw-semibold" [class.text-success]="log.total_profit >= 0" [class.text-danger]="log.total_profit < 0">{{log.total_profit | number:'1.2-2'}}</td>
          <td class="text-end fw-semibold" [class.text-success]="log.commission > 0">{{configuration.currency}} {{log.commission | number:'1.3-3'}}</td>
          <td class="text-end" [class.text-warning]="log.total_wallet_withdraw > 0">{{log.total_wallet_withdraw | number:'1.3-3'}}</td>
          <td class="text-end fw-bold" [class.text-success]="log.wallet_balance > 0">{{configuration.currency}} {{log.wallet_balance | number:'1.3-3'}}</td>
          <td class="text-center">
            <button class="btn btn-sm btn-outline-primary py-0" (click)="openDetail(log)">View</button>
          </td>
        </tr>
      </tbody>
      <tfoot class="table-dark">
        <tr>
          <td colspan="3" class="fw-semibold">Total ({{logs.length}})</td>
          <td class="text-end fw-bold">{{sum('total_in') | number:'1.2-2'}}</td>
          <td class="text-end fw-bold">{{sum('total_out') | number:'1.2-2'}}</td>
          <td class="text-end fw-bold">{{sum('total_profit') | number:'1.2-2'}}</td>
          <td class="text-end fw-bold">{{configuration.currency}} {{sum('commission') | number:'1.3-3'}}</td>
          <td class="text-end fw-bold">{{sum('total_wallet_withdraw') | number:'1.3-3'}}</td>
          <td class="text-end fw-bold">{{configuration.currency}} {{sum('wallet_balance') | number:'1.3-3'}}</td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>

  <!-- Detail Section -->
  <ng-container *ngIf="selected_log">
    <hr />
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h5 class="mb-0">Commission Detail &mdash; {{selected_log.name}} ({{selected_log.date}})</h5>
      <button class="btn btn-sm btn-outline-secondary" (click)="selected_log = null; commissionDetail = null">Close Detail</button>
    </div>

    <div class="text-center py-4" *ngIf="is_loading_detail">
      <div class="spinner-border"></div>
    </div>

    <ng-container *ngIf="!is_loading_detail && commissionDetail">
      <!-- Agent info -->
      <div class="d-flex gap-2 flex-wrap mb-3">
        <div class="border rounded px-3 py-2 bg-light">
          <small class="text-muted d-block">Period</small>
          <span class="fw-semibold">{{selected_log.date}}</span>
        </div>
        <div class="border rounded px-3 py-2 bg-light">
          <small class="text-muted d-block">Wallet Balance</small>
          <span class="fw-semibold text-success">{{configuration.currency}} {{selected_log.wallet_balance | number:'1.3-3'}}</span>
        </div>
        <div class="border rounded px-3 py-2" *ngIf="commissionDetail?.summary"
          [style.background]="commissionDetail.summary.total_profit >= 0 ? '#19875422' : '#dc354522'">
          <small class="text-muted d-block">Lifetime Profit</small>
          <span class="fw-semibold" [class.text-success]="commissionDetail.summary.total_profit >= 0" [class.text-danger]="commissionDetail.summary.total_profit < 0">
            {{configuration.currency}} {{commissionDetail.summary.total_profit | number:'1.2-2'}}
          </span>
        </div>
      </div>

      <!-- Daily Breakdown -->
      <div *ngIf="commissionDetail.report?.detail?.length > 0">
        <h6 class="fw-bold border-bottom pb-2 mb-2">Daily Breakdown</h6>
        <div class="table-responsive">
          <table class="table table-sm table-bordered table-hover">
            <thead class="table-dark">
              <tr>
                <th>Date</th>
                <th class="text-end">Deposit</th>
                <th class="text-end">Withdraw</th>
                <th class="text-end">Bonus</th>
                <th class="text-end">Brought Fwd</th>
                <th class="text-end">Commission</th>
                <th>Formula</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let day of commissionDetail.report.detail">
                <td class="fw-semibold">{{day.date}}</td>
                <td class="text-end text-success">{{configuration.currency}} {{(day.breakdown?.report?.total_deposit || day.breakdown?.total_deposit || 0) | number:'1.2-2'}}</td>
                <td class="text-end text-danger">{{configuration.currency}} {{(day.breakdown?.report?.total_withdraw || day.breakdown?.total_withdraw || 0) | number:'1.2-2'}}</td>
                <td class="text-end text-warning">{{configuration.currency}} {{(day.breakdown?.report?.total_bonus || day.breakdown?.total_bonus || 0) | number:'1.2-2'}}</td>
                <td class="text-end" [class.text-danger]="(day.breakdown?.report?.agent_balance || day.breakdown?.agent_balance || 0) < 0">
                  {{configuration.currency}} {{(day.breakdown?.report?.agent_balance || day.breakdown?.agent_balance || 0) | number:'1.2-2'}}
                </td>
                <td class="text-end fw-bold text-success">{{configuration.currency}} {{day.commission | number:'1.4-4'}}</td>
                <td>
                  <code class="small">{{day.formula}}</code>
                  <div class="text-muted small">{{agentFormulaText(day)}}</div>
                  <div *ngIf="day.breakdown?.deductions?.length" class="mt-1 d-flex flex-wrap gap-1">
                    <span *ngFor="let d of day.breakdown.deductions" class="badge bg-light text-dark border">
                      {{ d.code || ('Agent ' + d.agent_id) }}: {{ d.amount | number:'1.3-3' }}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Period total -->
      <div class="p-3 rounded bg-dark text-white d-flex justify-content-between align-items-center">
        <div>
          <div class="small opacity-75">Period Commission</div>
          <div class="small opacity-75">{{commissionDetail.report?.detail?.length || 0}} day(s)</div>
        </div>
        <div class="display-6 fw-bold">{{configuration.currency}} {{commissionDetail.report?.commission | number:'1.4-4'}}</div>
      </div>
    </ng-container>

    <div *ngIf="!is_loading_detail && !commissionDetail" class="text-muted py-3">No commission records found.</div>
  </ng-container>
</div>
